import { useEffect, useRef } from 'react';
import { Chart } from 'chart.js/auto';
import type { ChartDataset } from 'chart.js';

export type Dataset = ChartDataset<'line', number[]>;

// Same colours and options as the original admin (Chart.js line charts).
export function LineChart({ labels, datasets, fill = false }: { labels: string[]; datasets: Dataset[]; fill?: boolean }) {
  const canvas = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (!canvas.current) return;
    const chart = new Chart(canvas.current, {
      type: 'line',
      data: { labels: labels.length ? labels : ['No Data'], datasets },
      options: {
        responsive: true,
        maintainAspectRatio: !fill,
        plugins: { legend: { labels: { color: '#e0e0e0' } } },
        scales: {
          y: { ticks: { color: '#888', stepSize: 1 }, grid: { color: 'rgba(255,255,255,0.05)' } },
          x: { ticks: { color: '#888' }, grid: { display: false } },
        },
      },
    });
    return () => chart.destroy();
  }, [labels, datasets, fill]);
  return (
    <div className="chart-container">
      <canvas ref={canvas} style={fill ? { maxHeight: 300 } : undefined} />
    </div>
  );
}
